import request from '@/utils/request'

// 单点登录 - 登录
export function ssoLogin(query) {
  return request({
    url: '/blade-auth/sso/login',
    method: 'get',
    params: query
  })
}

// 国家平台统一认证 - 回调登录
export function ncnpAuthCallback(query) {
  return request({
    url: '/blade-auth/ncnp/auth/callback',
    method: 'get',
    params: query
  })
}

// 国家平台统一认证 - 授权地址
export function ncnpAuthorizeUrl(query) {
  return request({
    url: '/blade-auth/ncnp/auth/authorize-url',
    method: 'get',
    params: query
  })
}

// 国家平台 - 订单状态查询（含远端回拉）
export function ncnpOrderStatus(query) {
  return request({
    url: '/blade-system/ncnp/open/orders/status',
    method: 'get',
    params: query
  })
}

// 国家平台 - 生成支付/确认中转页跳转URL
export function ncnpOrderPayRedirect(query) {
  return request({
    url: '/blade-system/ncnp/open/orders/pay-redirect',
    method: 'get',
    params: query
  })
}

// 我的订单 - 订单详情
export function orderDetail(query) {
  return request({
    url: '/blade-system/orders/detail',
    method: 'get',
    params: query
  })
}

// 国家平台 - 商品同步（单条）
export function ncnpGoodsSync(query) {
  return request({
    url: '/blade-system/ncnp/goods/sync',
    method: 'post',
    params: query
  })
}

// 国家平台 - 商品同步重试
export function ncnpGoodsRetry() {
  return request({
    url: '/blade-system/ncnp/goods/retry',
    method: 'post'
  })
}

// 国家平台 - 商品批量同步
export function ncnpGoodsBatchSync(goodsIds) {
  return request({
    url: '/blade-system/ncnp/goods/batch-sync',
    method: 'post',
    data: goodsIds
  })
}

// 单点登录 - 登出
export function ssoLogout(query) {
  return request({
    url: '/blade-auth/sso/logout',
    method: 'get',
    params: query
  })
}

// 国家平台统一认证 - 登出
export function ncnpLogout(query) {
  return request({
    url: '/blade-auth/ncnp/auth/logout',
    method: 'post',
    params: query
  })
}

// 判断token是否有效
export function checkToken(query) {
  return request({
    url: '/blade-auth/sso/isToken',
    method: 'get',
    params: query
  })
}

// 我的订单 - 列表
export function ordersPage(query) {
  return request({
    url: '/blade-system/orders/page',
    method: 'get',
    params: query
  })
}

// 我的订单 - 统计
export function ordersTop(query) {
  return request({
    url: '/blade-system/orders/top',
    method: 'get',
    params: query
  })
}

// 算力资源管理 - 列表
export function goodsPage(query) {
  return request({
      url: "/blade-system/goods/list",
      method: "get",
      params: query,
      headers: {
          needLogin: false,
      },
  });
}

// 商品详情（订购页拉取）
export function goodsDetail(query) {
  return request({
    url: '/blade-system/goods/detail',
    method: 'get',
    params: query,
    headers: { needLogin: false }
  })
}

// 已上架商品的所属公司去重列表（算力市场筛选项）
export function goodsCompanies() {
  return request({
    url: '/blade-system/goods/companies',
    method: 'get',
    headers: { needLogin: false }
  })
}

// 订购页提交 —— 后端按 loginSource 分流 NCNP / 外部
// 契约见《长三角↔外部平台后端接口契约-v1.0.md》§6.1
export function placeOrder(payload) {
  return request({
    url: '/blade-system/api/order/create',
    method: 'post',
    data: payload
  })
}

// 新闻管理 - 列表
export function newsPage(query) {
  return request({
      url: "/blade-system/news/list",
      method: "get",
      params: query,
      headers: {
          needLogin: false,
      },
  });
}

// 新闻管理 - 详情
export function newsDetail(query) {
  return request({
      url: "/blade-system/news/detail",
      method: "get",
      params: query,
      headers: {
          needLogin: false,
      },
  });
}

//公告管理 - 列表
export function announcementPage(query) {
  return request({
      url: "/blade-system/announcement/list",
      method: "get",
      params: query,
      headers: {
          needLogin: false,
      },
  });
}

// 公共服务平台 - 列表
export function infoServicePage(query) {
  return request({
      url: "/blade-system/info/list",
      method: "get",
      params: query,
      headers: {
          needLogin: false,
      },
  });
}
